"use strict";
var btnContainer = document.querySelector(".gallery__controls-list");
var btns = document.querySelectorAll(".gallery__controls-btn");
var imgContainer = document.querySelector(".gallery__container-list");
var toTopBtn = document.querySelector(".footer__scroll-to-top");
var submitBtn = document.querySelector(".subscribe__submit-btn");
var ticketBtn = document.querySelector(".header__t-button");
var form = document.querySelector(".subscribe__form");
var btnIndex = 0;
var startX = 0;
var endX = 0;
var isMouseDown = false;
function computedMove(index) {
    var imgs = document.querySelectorAll(".gallery__image");
    var rectPrev = imgs[0].getBoundingClientRect();
    var rectNext = imgs[1].getBoundingClientRect();
    var spaceBetweenImg = rectNext.right - rectNext.width * 2 - rectPrev.left;
    var pureWidth = rectPrev.width + spaceBetweenImg;
    btns.forEach(function(btn) {
        btn.classList.remove("gallery__active-btn");
    });
    var activeBtn = Array.from(btns).find(function(btn) {
        return +btn.dataset.index === +index;
    });
    if (activeBtn) activeBtn.classList.add("gallery__active-btn");
    imgContainer.style.transform = "translateX(-".concat(pureWidth * index, "px)");
}
function isMove(event) {
    var element = event.target;
    if (element.closest(".gallery__controls-btn")) {
        btnIndex = +element.dataset.index;
        computedMove(btnIndex);
    }
}
function isActive() {
    btns[0].classList.add("gallery__active-btn");
    function isClick(e) {
        var element = e.target;
        if (element.closest(".gallery__controls-btn")) btns.forEach(function(btn) {
            btn.classList.remove("gallery__active-btn");
            element.classList.add("gallery__active-btn");
        });
    }
    btnContainer.addEventListener("click", isClick);
}
imgContainer.addEventListener("mousedown", function(e) {
    startX = e.clientX;
    isMouseDown = true;
});
imgContainer.addEventListener("touchstart", function(e) {
    startX = e.touches[0].clientX;
    isMouseDown = true;
});
document.addEventListener("mouseup", function(e) {
    if (isMouseDown) {
        endX = e.clientX;
        isMouseDown = false;
        var distanceX = endX - startX;
        if (distanceX > 0 && btnIndex > 0) {
            btnIndex--;
            computedMove(btnIndex);
        } else if (distanceX < 0 && btnIndex < btns.length - 1) {
            btnIndex++;
            computedMove(btnIndex);
        }
    }
});
document.addEventListener("touchend", function(e) {
    if (isMouseDown) {
        endX = e.changedTouches[0].clientX;
        isMouseDown = false;
        var distanceX = endX - startX;
        if (distanceX > 0 && btnIndex > 0) {
            btnIndex--;
            computedMove(btnIndex);
        } else if (distanceX < 0 && btnIndex < btns.length - 1) {
            btnIndex++;
            computedMove(btnIndex);
        }
    }
});
function scrollTo() {
    window.scroll(0, 0);
}
function onSubmit(event) {
    var field = form.querySelector(".subscribe__field");
    if (field.value) {
        event.preventDefault();
        form.reset();
        window.scroll(0, 0);
    }
}
toTopBtn.addEventListener("click", scrollTo);
document.addEventListener("DOMContentLoaded", isActive, {
    once: true
});
btnContainer.addEventListener("click", isMove);
document.addEventListener("DOMContentLoaded", function() {
    var menuBtn = document.querySelector(".icon--menu");
    var closeBtn = document.querySelector(".icon--close");
    var menuNav = document.querySelector(".menu__nav");
    menuBtn.addEventListener("click", function() {
        document.documentElement.classList.add("menu-open");
    });
    closeBtn.addEventListener("click", function() {
        document.documentElement.classList.remove("menu-open");
    });
    menuNav.addEventListener("click", function() {
        document.documentElement.classList.remove("menu-open");
    });
});
submitBtn.addEventListener("click", onSubmit);
ticketBtn.addEventListener("click", function() {
    document.querySelector(".performances").scrollIntoView();
}); // function handleResize() {
 //   const content = document.querySelector('.page__container');
 //   const header = document.querySelector('.header__container');
 //   if (content && header) {
 //     const rect = content.getBoundingClientRect();
 //     header.style.marginLeft = `${rect.x}px`;
 //   }
 // }
 // window.addEventListener('resize', handleResize);
 // window.addEventListener('load', handleResize);

//# sourceMappingURL=index.2a7f3d6f.js.map
